import { IApplicationContext } from 'shared/types/applicationContext';
import { TFetchFormParams } from 'shared/types/form';
import { TSendFormResponse } from './types';

export async function fetchForm(
  { httpApi, custom: { userId } }: IApplicationContext,
  params: TFetchFormParams,
): Promise<TSendFormResponse> {
  const { response, statusCode } = await httpApi.fetch(
    {
      apiType: 'external',
      microserviceName: 'info-api',
      assertStatusCodes: [200, 400],
      method: 'POST',
      pathApi: '/api/pik/v2/save-form-request',
      requestContentType: 'json',
      parameters: { ...params, userId: userId ? Number(userId) : undefined },
    },
    {
      requestConfig: {
        headers: [['Content-Type', 'application/json']],
      },
    },
  );

  return { statusCode, response } as TSendFormResponse;
}
